import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { UserRole } from '../auth';

export type UserCreateAdminData = AnyObject

export type UserCreateAdminResponse = UserCreateAdminData

export interface UserCreateAdminBody {
  email: string;
  role: UserRole;
  yearBirth: number | null;
  zipCode: string | null;
  name: string;
  phone: string | null;
  countryId: number | null;
  photoId: string | null;
  description: string | null;
  categoryId: string | null;
  subCategoryId: string | null;
}

export const userCreateAdmin = (payload: UserCreateAdminBody): Action<UserCreateAdminBody> => ({
  type: actions.userCreateAdminTrigger.toString(),
  payload,
});

export const userCreateAdminClear = (): Action => ({
  type: actions.userCreateAdminClear.toString(),
});

export const userCreateAdminErrorClear = (): Action => ({
  type: actions.userCreateAdminErrorReset.toString(),
});

export function* userCreateAdminRequestSaga({ payload }: Action<UserCreateAdminBody>) {
  yield put({
    type: actions.userCreateAdminStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.userCreateAdminError.toString(),
      payload: {
        message: 'UserCreateAdmin: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/users/as-admin?site=admin_panel`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<UserCreateAdminData, UserCreateAdminResponse>(
    response,
    actions.userCreateAdminSuccess.toString(),
    actions.userCreateAdminError.toString(),
    false,
    (userCreateAdminData) => userCreateAdminData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.userCreateAdminTrigger.toString(),
    defaultProcessingSaga(
      userCreateAdminRequestSaga,
      {
        error: actions.userCreateAdminError.toString(),
        locationCancel: actions.userCreateAdminClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.userCreateAdminSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.userCreateAdminClear.toString(),
    // });
  });

  yield takeLatest(actions.userCreateAdminError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.userCreateAdminErrorReset.toString(),
    });
  });
}
